import { ToyBrick } from "lucide-react";
// React import removed: no JSX transform requirement in this project

import { Card } from "../../components/ui/Card";
import { ProductCategoryPannel } from "./ProductCategoryPannel";

// Product type imported from reusable hook

// Category UI moved to ProductCategoryPannel

export function CategoryPage() {
  // Categories logic lives in ProductCategoryPannel

  return (
    <div className="p-6 space-y-8 bg-background min-h-screen">
      {/* Header */}
      <Card className="flex justify-between items-center">
        <div className="flex items-center gap-2">
          <ToyBrick className="w-8 h-8 text-green-600" />
          <div>
            <h1 className="text-2xl font-bold text-foreground">Categorii</h1>
          </div>
        </div>
      </Card>

      {/* Categories Management Panel */}
      <ProductCategoryPannel />
    </div>
  );
}
